export enum TopUserMenuActionTypes {
  LOGOUT = '[User Menu] Logout',
  ACCOUNT_SETTINGS = '[User Menu] Account Settings',
  SUBSCRIPTIONS = '[User Menu] Subscriptions',
  API_TOKEN = '[User Menu] API Token',
}

export class TopUserMenuLogoutAction {
  public readonly type = TopUserMenuActionTypes.LOGOUT;
}

export class TopUserMenuAccountSettingsAction {
  public readonly type = TopUserMenuActionTypes.ACCOUNT_SETTINGS;
}

export class TopUserMenuSubscriptionsAction {
  public readonly type = TopUserMenuActionTypes.SUBSCRIPTIONS;
}

export class TopUserMenuApiTokenAction {
  public readonly type = TopUserMenuActionTypes.API_TOKEN;
}

export type TopUserMenuActionsUnion =
  TopUserMenuLogoutAction | TopUserMenuAccountSettingsAction | TopUserMenuSubscriptionsAction | TopUserMenuApiTokenAction;
